"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorInputPair = void 0;
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireDefault(require("react"));
var _useTheme = require("../../../../../../theme/utils/useTheme");
var _textinput = require("../../../../../textinput");
var _ColorInputLabel = require("../styled/ColorInputLabel");
const ColorInputPair = props => {
  const {
    allowedCharacters,
    className,
    flexGrow,
    value,
    onChange,
    label,
    clientId,
    isValid,
    width
  } = props;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const regex = new RegExp(`[^${allowedCharacters}]`);
  const changeHandler = value => {
    const newValue = value.replace(regex, "");
    onChange(newValue);
  };
  return /*#__PURE__*/_react.default.createElement(_ColorInputLabel.ColorInputLabel, {
    flexGrow: flexGrow,
    width: width,
    className: className,
    "data-client-id": clientId,
    htmlFor: "a97112c72dbf_" + label,
    themeMode: themeMode
  }, /*#__PURE__*/_react.default.createElement(_textinput.TextInput, {
    validationState: isValid ? undefined : "error",
    onChange: changeHandler,
    value: value,
    clientId: (0, _lodestarUtils.getClientId)(clientId, "input"),
    id: "a97112c72dbf_" + label
  }), /*#__PURE__*/_react.default.createElement("span", {
    "data-client-id": (0, _lodestarUtils.getClientId)(clientId, "text")
  }, label));
};
exports.ColorInputPair = ColorInputPair;
ColorInputPair.displayName = "ColorInputPair";
//# sourceMappingURL=ColorInputPair.js.map